import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TemplateGalleryPage } from '@/features/editor/templates/template-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** « Partir d'un gabarit » (#54) : la galerie de gabarits low-code livrée avec graal-api. */
export const Route = createFileRoute('/$tenant/editor/templates/')({ component: TemplatesRoute });

function TemplatesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="editor"
      crumbs={[{ label: t('nav.items.editor') }, { label: t('gallery.title') }]}
    >
      <TemplateGalleryPage tenantId={tenant} />
    </ConsoleShell>
  );
}
